import { gql } from '@apollo/client';

export const CREATE_FUNDERS = gql`
  mutation createFunders($inputs: [UpsertFunderInput!]!) {
    createFunders(inputs: $inputs) {
      id
    }
  }
`;
